module.exports = __webpack_public_path__ + "img/logo.cea39755.png";